/**
 * A guard for a closed vocabulary: the value when it is one of `values`, else null. The mappers
 * leave out what the workspace does not know rather than guess.
 */
export const known =
  <T extends string>(values: readonly T[]) =>
  (value: string | null | undefined): T | null =>
    values.find(item => item === value) ?? null

/** Not null: `.filter(present)` keeps what a mapper could read. */
export const present = <T>(value: T | null): value is T => value !== null
